import React from 'react';
import {StudioTextField} from '../../../../base-components/StudioTextField';
import {FormattedMessage, useIntl} from 'react-intl';
import {Accordion, AccordionDetails, AccordionSummary} from '@material-ui/core';
import {ExpandMore} from '@material-ui/icons';
import {ModelPurpose} from '../../../../types/model/ModelPurpose';

type ApplicationSettingsProps = {
  modelPurpose?: ModelPurpose;
  isAnalytics?: boolean;
  settings?: {
    tasks: string;
    verbose: number | string;
    device: string;
    calendar: string;
    videoStream: string;
    blackoutPeriod: number | string;
    regions: string;
    durations: number | string;
    date: Date | string;
    version: string;
    taskName: string;
    rest_url: string;
    author: string;
    token: string;
    ws_url: string;
  };
};

const ApplicationSettings = ({
  settings,
  modelPurpose,
  isAnalytics,
}: ApplicationSettingsProps) => {
  const intl = useIntl();
  return modelPurpose === 'Other' && isAnalytics ? null : (
    <Accordion elevation={0} defaultExpanded className={`deploy-settings`}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        className="deploy-settings__title-container"
      >
        <FormattedMessage tagName="h4" id="applicationSettings.title" />
      </AccordionSummary>

      <AccordionDetails className="deploy-settings__body_container">
        {/* {modelPurpose === 'Detection' ? ( */}
        {!modelPurpose ? (
          <div className="dplmt-config-field-container">
            <StudioTextField
              placeholder="Value"
              value={settings?.tasks}
              label={intl.formatMessage({
                id: 'applicationSettings.tasks',
              })}
              fullWidth
            />
            <StudioTextField
              placeholder="Value"
              value={settings?.verbose}
              label={intl.formatMessage({
                id: 'applicationSettings.verbose',
              })}
              fullWidth
            />
            <StudioTextField
              placeholder="Value"
              value={settings?.device}
              label={intl.formatMessage({
                id: 'applicationSettings.device',
              })}
              fullWidth
            />
            <StudioTextField
              placeholder="Value"
              value={settings?.calendar}
              label={intl.formatMessage({
                id: 'applicationSettings.calendar',
              })}
              fullWidth
            />
            <StudioTextField
              placeholder="Value"
              value={settings?.videoStream}
              label={intl.formatMessage({
                id: 'applicationSettings.videoStream',
              })}
              fullWidth
            />
            <StudioTextField
              placeholder="Value"
              value={settings?.blackoutPeriod}
              label={intl.formatMessage({
                id: 'applicationSettings.blackoutPeriod',
              })}
              fullWidth
            />
            <StudioTextField
              placeholder="Value"
              value={settings?.regions}
              label={intl.formatMessage({
                id: 'applicationSettings.regions',
              })}
              fullWidth
            />
            <StudioTextField
              placeholder="Value"
              value={settings?.durations}
              label={intl.formatMessage({
                id: 'applicationSettings.durations',
              })}
              fullWidth
            />
            <StudioTextField
              placeholder="Value"
              value={settings?.date}
              label={intl.formatMessage({
                id: 'applicationSettings.date',
              })}
              fullWidth
            />
            <StudioTextField
              placeholder="Value"
              value={settings?.version}
              label={intl.formatMessage({
                id: 'applicationSettings.version',
              })}
              fullWidth
            />
            <StudioTextField
              placeholder="Value"
              value={settings?.taskName}
              label={intl.formatMessage({
                id: 'applicationSettings.taskName',
              })}
              fullWidth
            />
            <StudioTextField
              placeholder="Value"
              value={settings?.rest_url}
              label={intl.formatMessage({
                id: 'applicationSettings.rest_url',
              })}
              fullWidth
            />
            <StudioTextField
              placeholder="Value"
              value={settings?.author}
              label={intl.formatMessage({
                id: 'applicationSettings.author',
              })}
              fullWidth
            />
            <StudioTextField
              placeholder="Value"
              value={settings?.token}
              label={intl.formatMessage({
                id: 'applicationSettings.token',
              })}
              fullWidth
            />
            <StudioTextField
              placeholder="Value"
              value={settings?.ws_url}
              label={intl.formatMessage({
                id: 'applicationSettings.ws_url',
              })}
              fullWidth
            />
          </div>
        ) : (
          <div className="deploy-settings__body_container__no_settings">
            <FormattedMessage id={'settings.none'} />
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default ApplicationSettings;
